import { SET_TECH } from "./techTypes";


export const setTech = (response) => {
  return {
    type: SET_TECH,
    payload: response,
  };
};
